import React, { Component, Fragment } from "react";
// Externals
import classNames from "classnames";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
// Material helpers
import { withStyles } from "@material-ui/core";
import { cacheQueries } from "../../../../apollo/queries/cache";

// Material components
import {
  // Badge,
  IconButton,
  Popover,
  Toolbar,
  Typography
} from "@material-ui/core";

// Material icons
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  // NotificationsOutlined as NotificationsIcon,
  Input as InputIcon,
  Language as LanguageIcon
} from "@material-ui/icons";

// Shared services
import { getNotifications } from "services/notification";

// Custom components
import { NotificationList } from "./components";

// Component styles
import styles from "./styles";
//language
// import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const { GET_LANGUAGE, GET_DIRECTION, IS_LOGIN, GET_TOKEN } = cacheQueries;

class Topbar extends Component {
  signal = true;
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      notificationsLimit: 4,
      notificationsCount: 0,
      notificationsEl: null,
      anchorEl: null
    };
  }

  async getNotifications() {
    try {
      const { notificationsLimit } = this.state;

      const { notifications, notificationsCount } = await getNotifications(
        notificationsLimit
      );

      if (this.signal) {
        this.setState({
          notifications,
          notificationsCount
        });
      }
    } catch (error) {
      return;
    }
  }

  componentDidMount() {
    this.signal = true;
    this.getNotifications();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  handleSignOut = () => {
    // TODO resolver needed
    this.props.client.writeQuery({
      query: GET_TOKEN,
      data: { token: null }
    });
    this.props.client.writeQuery({
      query: IS_LOGIN,
      data: { isLogin: false }
    });
  };

  handleShowNotifications = event => {
    this.setState({
      notificationsEl: event.currentTarget
    });
  };

  handleCloseNotifications = () => {
    this.setState({
      notificationsEl: null
    });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handelLanguage = ({ language, direction }) => {
    // TODO resolver needed
    console.log(language, direction);
    this.props.client.writeQuery({
      query: GET_DIRECTION,
      data: { direction }
    });
    this.props.client.writeQuery({
      query: GET_LANGUAGE,
      data: { language }
    });
  };
  render() {
    const {
      classes,
      className,
      title,
      isSidebarOpen,
      onToggleSidebar,
      // language,
      direction
    } = this.props;
    const {
      notifications,
      // notificationsCount,
      notificationsEl,
      anchorEl
    } = this.state;

    const rootClassName = classNames(classes.root, className);
    const showNotifications = Boolean(notificationsEl);

    return (
      <Fragment>
        <div className={rootClassName}>
          <Toolbar
            className={
              direction === "rtl" ? classes.toolbar : classes.toolbarLtr
            }
          >
            <IconButton
              className={classes.menuButton}
              onClick={onToggleSidebar}
              variant="text"
            >
              {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Typography className={classes.title} variant="h4">
              {title}
            </Typography>
            {/* <IconButton
              className={classes.notificationsButton}
              onClick={this.handleShowNotifications}
            >
              <Badge
                badgeContent={notificationsCount}
                color="primary"
                variant="dot"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton> */}
            <IconButton
              className={
                direction === "rtl" ? classes.rtlIcon : classes.ltrIcon
              }
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={e => this.setState({ anchorEl: e.currentTarget })}
            >
              <LanguageIcon />
            </IconButton>
            <IconButton
              className={classes.signOutButton}
              onClick={this.handleSignOut}
            >
              <InputIcon />
            </IconButton>

            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem
                onClick={() => {
                  this.handelLanguage({ language: "fa", direction: "rtl" });
                  this.handleClose();
                }}
              >
                Persian
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.handelLanguage({ language: "en", direction: "ltr" });
                  this.handleClose();
                }}
              >
                English
              </MenuItem>
            </Menu>
          </Toolbar>
        </div>
        <Popover
          anchorEl={notificationsEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          onClose={this.handleCloseNotifications}
          open={showNotifications}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          <NotificationList
            notifications={notifications}
            onSelect={this.handleCloseNotifications}
          />
        </Popover>
      </Fragment>
    );
  }
}

Topbar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  // history: PropTypes.object.isRequired,
  isSidebarOpen: PropTypes.bool,
  onToggleSidebar: PropTypes.func,
  title: PropTypes.string
};

Topbar.defaultProps = {
  onToggleSidebar: () => {}
};

export default withApollo(withStyles(styles)(Topbar));
